import React, { useState } from "react";
import { Container, TabContainer, TabNavigationTab } from "./BillingStyles";

import Tab from "../../components/common/Tab/Tab";
import InvoiceTable from "../../components/BillingComponents/InvoiceTable";

const Billing = () => {
  const initState = {
    bills: true,
    advertisers: false,
  };

  const [tab, setTab] = useState(initState);

  return (
    <Container>
      <div className="header">
        <div className="texts">
          <h3>Payments</h3>
          <p>
            Manage transaction history, payment approvals, and billing issues
          </p>
        </div>
      </div>

      <>
        <TabContainer>
          <TabNavigationTab>
            <ul>
              <li>
                <a
                  href="#bills"
                  className={tab.bills ? "active" : ""}
                  onClick={() =>
                    setTab((tab) => ({ ...initState, bills: true }))
                  }
                >
                  Bill
                </a>
              </li>
              <li>
                <a
                  href="#advertisers"
                  className={tab.advertisers ? "active" : ""}
                  onClick={() =>
                    setTab((tab) => ({
                      ...initState,
                      bills: false,
                      advertisers: true,
                      publishers: false,
                    }))
                  }
                >
                  Payment History
                </a>
              </li>
            </ul>
          </TabNavigationTab>
        </TabContainer>

        <div className="tab-content">
          {tab.bills && (
            <>
              <InvoiceTable />
            </>
          )}
          {tab.advertisers && (
            <>
              <Tab billing />
            </>
          )}
        </div>
      </>
    </Container>
  );
};

export default Billing;
